import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { BookOpen } from "lucide-react";
import { getRequestKnowledge } from "../../actions/requestKnowledge";

const AdminMenu = () => {
  const [isReferent, setIsReferent] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);

  const dispatch = useDispatch();
  const knowledgeRequest = useSelector(
    (state) => state.requestKnowledgeReducer
  );
  const userData = useSelector((state) => state.userReducer);

  const requestWait = Object.values(knowledgeRequest).filter((knowledge) => {
    return knowledge.requestStatus === "0";
  });

  const rowsRequest = requestWait.length;

  useEffect(() => {
    dispatch(getRequestKnowledge());
  }, [dispatch]);

  useEffect(() => {
    const checkAdmin = () => {
      if (userData.isAdmin) {
        setIsAdmin(true);
      } else if (userData.isReferent) {
        setIsReferent(true);
      }
    };
    checkAdmin();
  }, [userData.isAdmin, userData.isReferent]);

  return (
    <div className="leftBlock">
      <div className="left_menu">
        {isAdmin ? (
          <>
            <ul className="li">
              <i className="fa-solid fa-house"></i>
              <Link to={"/dashboard"}>Dashboard</Link>
            </ul>
            <ul className="li">
              <i className="fa-regular fa-address-card"></i>
              <Link to={"/adminUsers"}>Gérer les utilisateurs</Link>
            </ul>
          </>
        ) : null}
        {isReferent || isAdmin ? (
          <ul className="li">
            <i className="far fa-newspaper"></i>
            <Link to={"/requestKnowledge"}>Demandes de Tutoriels</Link>
            <span className="numberRow"> {rowsRequest}</span>
          </ul>
        ) : null}
        {isAdmin ? (
          <ul className="li">
            <i className="fa-solid fa-toolbox"></i>
            <Link to={"/nosoutilsExt"}>Coffre Fort</Link>
          </ul>
        ) : null}
        {isAdmin ? (
          <ul className="li">
            <i className="fa-solid fa-screwdriver-wrench"></i>
            <Link to={"/boiteaoutils"}>Boite à outils</Link>
          </ul>
        ) : null}
        {isAdmin || isReferent ? (
          <ul className="li">
            <i className="fa-solid fa-screwdriver-wrench"></i>
            <Link to={"/chatbotadmin"}>Chatbot</Link>
          </ul>
        ) : null}
        {isAdmin || isReferent ? (
          <ul className="li admin-menu-academy">
            <BookOpen size={16} />
            <Link to={"/admin/formations"}>
              <span className="ama-skills">Skills</span>{" "}
              <span className="ama-academy">Academy</span>
            </Link>
          </ul>
        ) : null}
      </div>
    </div>
  );
};

export default AdminMenu;
